import { isArray } from "@huub-web/utils";
import {
  Flex,
  type FlexProps,
  Icon,
  Obscured,
  Separate,
  Text,
  ValueParser,
} from "@huub-web/ui";

import { iconStyle, priceStyle } from "../WinningBidCard.css";

export type BidValueProps = {
  value?: number | [number, number] | null;
  align?: FlexProps["align"];
  justify?: FlexProps["justify"];
};

export const BidValue = ({
  value,
  align = "center",
  justify = "center",
}: BidValueProps) => (
  <Flex align={align} gap="xs" className={priceStyle} justify={justify}>
    {value ? (
      isArray(value) ? (
        <Flex wrap align="center" gap="xxs" justify="center">
          <Separate
            separator={
              <Text variant="displayS" bold>
                —
              </Text>
            }
          >
            {value.map((v, index) => (
              <Text key={index} variant="displayS" bold align="center">
                <ValueParser value={{ value: v, type: "money" }} />
              </Text>
            ))}
          </Separate>
        </Flex>
      ) : (
        <Text variant="displayS" noWrap bold align="center">
          <ValueParser value={{ value, type: "money" }} />
        </Text>
      )
    ) : (
      <>
        <Icon icon="euro" size="s2" className={iconStyle} />
        <Obscured locked>
          <Text variant="displayS" noWrap>
            000.000
          </Text>
        </Obscured>
      </>
    )}
  </Flex>
);
